<template>
  <Toast/>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="page-header centrer">
            <div class="row">
              <div class="col-1"/>
              <div class="col-10">
                <h1>Audits des changements - Dossiers</h1>
              </div>
              <div class="col-1 text-right no-print">
                  <Button class="no-print" label="Fermer" v-on:click="fermer"/>
              </div>
            </div>
            <h3 class="confidentiel">Confidentiel</h3>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <table class="centrer">
            <thead>
              <tr>
                <td>
                  <!--place holder for the fixed-position header-->
                  <div class="page-header-space"></div>
                </td>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <!--*** CONTENT GOES HERE ***-->
                  <div>
                    <TableModifications @backendError="showError" @isDataLoaded="getIsDataLoaded"/>
                  </div>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td>
                  <!--place holder for the fixed-position footer-->
                  <div class="page-footer-space"></div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="page-footer centrer">
            <p>Généré le {{ getCurrentDateTime() }} par {{ currentUser }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableModifications from "../../components/dossier/AuditModifications/TableModifications.vue";
import axios from 'axios';
import { mapGetters } from "vuex";

export default {
  name: "DossierAuditModifications",
  components: {
    TableModifications,
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Audit des modifications Dossier");
    this.$store.dispatch("vehicule/obtenirProfilAction").then((res) => {
      this.assignerInformationUtilisateur(res);
    }).catch((err) => { console.error(err) });
  },
  data() {
    return {
      currentUser: "",
      isDataLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      dossier: "dossier/dossier",
    }),
  },
  methods: {
    assignerInformationUtilisateur(res) {
      this.currentUser = res.data.codeProfilUtilisateur;
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    getCurrentDateTime() {
      return this.$commun.formatDateHeure(new Date());
    },
    getIsDataLoaded(value) {
      this.isDataLoaded = value;
    },
    showError(error) {
      this.$toast.add({
        severity: 'error',
        summary: 'Audits',
        detail: 'Erreur lors de la récupération des audits du dossier: ' + error,
        life: 5000
      })
    },
  },
};
</script>